/* unplugin-vue-components disabled */import { render } from "./cp_fav.vue?vue&type=template&id=199b8686&scoped=true"
import script from "./cp_fav.vue?vue&type=script&lang=js"
export * from "./cp_fav.vue?vue&type=script&lang=js"

import "./cp_fav.vue?vue&type=style&index=0&id=199b8686&scoped=true&lang=css"

import exportComponent from "H:\\高报云\\HZY\\Code\\HZY.Mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199b8686"]])

export default __exports__